export const USER = 'user'
const ROUTER = {
  DEFAULT: '/',
  SVG_VIEWER: '/svg-viewer',
  HOME: '/',

  //ANONYMOUS
  CAP_NHAT_THONG_TIN: '/cap-nhat-thong-tin',
  LICH_HOP_CUA_TOI: '/lich-hop-cua-toi',
  DANG_KY_LICH_HOP: '/dang-ky-lich-hop',
  DANG_KY_RA_VAO: '/dang-ky-ra-vao',
  DANG_KY_KHACH: '/dang-ky-khach',

  // ADMIN
  THONG_KE_RA_VAO: '/thong-ke-ra-vao',
  QUAN_LY_PHAN_QUYEN: '/phan-quyen',
  QUAN_LY_DANH_MUC_CHUC_NANG: '/danh-muc-chuc-nang',
  DUYET_TAI_KHOAN_NHAN_VIEN: '/duyet-tai-khoan-nhan-vien',
  DUYET_THAY_DOI_THONG_TIN: '/duyet-thay-doi-thong-tin',
  DUYET_DON_NGHI: '/duyet-don-nghi',
  CHI_TIET_KHACH_HEN: '/chi-tiet-khach-hen',
  CHI_TIET_THONG_KE_NGHI_PHEP_PHONG_BAN: '/chi-tiet-thong-ke-nghi-phep-phong-ban',
  PRODUCT: '/product',

  // Module legacy — categoryID xác nhận thật từ GetListTab (docs/superpowers/plans/observed-json.md
  // + curl verify), trang đích còn là ComingSoon stub cho tới khi build feature thật.
  LINH_VUC_KINH_DOANH: '/danh-muc/linh-vuc-kinh-doanh',
  LINH_VUC_HOAT_DONG: '/linh-vuc-hoat-dong',
  DIA_GIOI_HANH_CHINH: '/dia-gioi-hanh-chinh',
  TINH_THANH: '/tinh-thanh',
  XA_PHUONG: '/xa-phuong',
  DON_VI_DO_LUONG: '/don-vi-do-luong',
  DON_VI_QUAN_LY: '/don-vi-quan-ly',
  DANH_MUC_SAN_PHAM: '/danh-muc-san-pham',
  THONG_KE_TONG_QUAN: '/thong-ke-tong-quan',
  DASHBOARD: '/dashboard',
  DON_HANG: '/don-hang',
  CUNG_CAU: '/cung-cau',
  DOANH_NGHIEP: '/doanh-nghiep',
  DANG_KY_DOANH_NGHIEP: '/dang-ky-doanh-nghiep',
  DANG_KY_DOANH_NGHIEP_WIZARD: '/dang-ky-tao-doanh-nghiep',
  DANG_KY_KHUYEN_MAI: '/dang-ky-khuyen-mai',
  DANG_KY_SAN_PHAM: '/dang-ky-san-pham',
  DOI_TAC: '/doi-tac',
  AN_TOAN_SAN_XUAT: '/an-toan-san-xuat',
  NHAT_KY_SAN_PHAM: '/nhat-ky-san-pham',
  CHUOI_CUNG_UNG: '/chuoi-cung-ung',
  DON_SAN_XUAT: '/don-san-xuat',
  VUNG_SAN_XUAT: '/vung-san-xuat',
  BAO_CAO_DOANH_NGHIEP: '/bao-cao-doanh-nghiep',
  BAO_CAO_SAN_PHAM: '/bao-cao-san-pham',
  THONG_KE_TEM_NHAN: '/thong-ke-tem-nhan',
  THONG_KE_SAN_PHAM: '/thong-ke-san-pham',
  THONG_KE_DON_SAN_XUAT: '/thong-ke-don-san-xuat',
  THONG_KE_TEM_NHAN_DOANH_NGHIEP: '/thong-ke-tem-nhan-doanh-nghiep',
  THONG_KE_DON_HANG: '/thong-ke-don-hang',
  THONG_KE_CUNG_CAU: '/thong-ke-cung-cau',
  BAO_CAO_SAN_PHAM_DOANH_NGHIEP: '/bao-cao-san-pham-doanh-nghiep',
  BAO_CAO_DOI_TAC: '/bao-cao-doi-tac',
  THONG_KE_DOANH_NGHIEP_DN: '/thong-ke-doanh-nghiep-dn',
  CAI_DAT_CHUNG: '/cai-dat-chung',
  CAI_DAT_CHUNG_TIEN_TO: '/cai-dat-chung-tien-to',
  CAI_DAT_LICH_LAM_VIEC: '/cai-dat-lich-lam-viec',
  QUAN_LY_NGUOI_DUNG: '/quan-ly-nguoi-dung',
  NHAT_KY_HE_THONG: '/nhat-ky-he-thong',
  PRODUCT_OCOP: '/products-ocop',
  STAFF_REGISTRATION: '/dang-ky-nguoi-dung',
  PRODUCT_OCOP_REGISTER: '/products-ocop-register',
  PRODUCT_PROMOTION: '/khuyen-mai',
  CHANGE_PASSWORD: '/user/change-password',
  QUAN_LY_MENU: '/quan-ly-menu',
  THIET_LAP_KET_NOI: '/thiet-lap-ket-noi',
  QUAN_LY_MA_TEM: '/quan-ly-ma-tem',
  DANG_KY_MA_TEM: '/dang-ky-ma-tem',

  //User
  THONG_TIN_TAI_KHOAN: `/${USER}/thong-tin-ca-nhan`,
  LICH_SU_CAP_NHAT_THONG_TIN: `/${USER}/lich-su-cap-nhat-thong-tin`,
  DANH_SACH_KHIEU_NAI: '/acs/danh-sach-khieu-nai',
  CHI_TIET_KHIEU_NAI: '/chi-tiet-khieu-nai/:id',
}
export default ROUTER
